/** Stable remount key for the shell outlet (pathname, query, history entry). */
export function keyedRouteOutletKey(input: {
  pathname: string;
  search: string;
  key: string;
}): string {
  return `${input.pathname}${input.search}::${input.key}`;
}
